import React, { useState } from 'react';
import { Container, Row, Col, Nav, Button, Image, Accordion } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import UserProfile from './components/UserProfile';
import ActivityFeed from './components/ActivityFeed';
import Projects from './components/Projects';
import Analytics from './components/Analytics';
import ExploitCentre from './components/ExploitCentre';
import AdminPanel from './components/AdminPanel';
import Roster from './components/Roster';
import ResourceCentre from './components/ResourceCentre';
import Training from './components/Training';
import Writeups from './components/Writeups';
import ProDevelopment from './components/ProDevelopment';
import './Dashboard.css';
import { useAuth } from './AuthContext';

function Dashboard() {
  const [activeKey, setActiveKey] = useState('profile');
  const navigate = useNavigate();
  const { user, loading, authenticated, logout } = useAuth();

  const handleSignOut = async () => {
    await logout();
    navigate('/');
  };

  if (loading) return <div className="loading-spinner"></div>;

  if (!authenticated) {
    navigate('/');
    return null;
  }

  const userData = {
    username: user?.username || '',
    rank: user?.rank || '',
    profile_picture: user?.profile_picture || '/default-profile.svg',
  };

  return (
    <Container fluid className="dashboard-container">
      <Row>
        <Col xs={2} style={{ width: '12.5%' }} className="sidebar">
        <div className="company-logo">
          <img src="/logo.png" alt="Fedoraman Project Logo" className="logo-icon" />
        </div>

          <Accordion className="nav-accordion">
            {/* Personal & Activity */}
            <Accordion.Item eventKey="0" className="nav-accordion-item">
              <Accordion.Header>Personal & Activity</Accordion.Header>
              <Accordion.Body>
                <Nav.Link
                  className={activeKey === 'profile' ? 'active' : ''}
                  onClick={() => setActiveKey('profile')}
                >
                  Profile
                </Nav.Link>
                <Nav.Link
                  className={activeKey === 'activity' ? 'active' : ''}
                  onClick={() => setActiveKey('activity')}
                >
                  Activity Feed
                </Nav.Link>
              </Accordion.Body>
            </Accordion.Item>

            {/* Operations */}
            <Accordion.Item eventKey="1" className="nav-accordion-item">
              <Accordion.Header>Operations</Accordion.Header>
              <Accordion.Body>
                <Nav.Link
                  className={activeKey === 'projects' ? 'active' : ''}
                  onClick={() => setActiveKey('projects')}
                >
                  Projects
                </Nav.Link>
                <Nav.Link
                  className={activeKey === 'exploit-centre' ? 'active' : ''}
                  onClick={() => setActiveKey('exploit-centre')}
                >
                  Exploit Centre
                </Nav.Link>
                <Nav.Link
                  className={activeKey === 'training' ? 'active' : ''}
                  onClick={() => setActiveKey('training')}
                >
                  Training
                </Nav.Link>
                <Nav.Link
                  className={activeKey === 'writeups' ? 'active' : ''}
                  onClick={() => setActiveKey('writeups')}
                >
                  Writeups
                </Nav.Link>
              </Accordion.Body>
            </Accordion.Item>

            {/* Resources & Team */}
            <Accordion.Item eventKey="2" className="nav-accordion-item">
              <Accordion.Header>Resources & Team</Accordion.Header>
              <Accordion.Body>
                <Nav.Link
                  className={activeKey === 'roster' ? 'active' : ''}
                  onClick={() => setActiveKey('roster')}
                >
                  Roster
                </Nav.Link>
                <Nav.Link
                  className={activeKey === 'resource-centre' ? 'active' : ''}
                  onClick={() => setActiveKey('resource-centre')}
                >
                  Resource Centre
                </Nav.Link>
                <Nav.Link
                  className={activeKey === 'professional-development' ? 'active' : ''}
                  onClick={() => setActiveKey('professional-development')}
                >
                  Professional Development
                </Nav.Link>
              </Accordion.Body>
            </Accordion.Item>

            {/* Analysis & Management */}
            <Accordion.Item eventKey="3" className="nav-accordion-item">
              <Accordion.Header>Analysis & Management</Accordion.Header>
              <Accordion.Body>
                <Nav.Link
                  className={activeKey === 'analytics' ? 'active' : ''}
                  onClick={() => setActiveKey('analytics')}
                >
                  Analytics
                </Nav.Link>
                <Nav.Link
                  className={activeKey === 'admin' ? 'active' : ''}
                  onClick={() => setActiveKey('admin')}
                >
                  Admin Panel
                </Nav.Link>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>

          <div className="user-info">
            <Image src={userData.profile_picture} roundedCircle className="profile-picture2" alt="Profile Picture" />
            <div className="user-details">
              <strong>{userData.username}</strong>
              <small>{userData.rank}</small>
            </div>
            <Button variant="danger" className="sign-out-button" onClick={handleSignOut}>
              Sign Out
            </Button>
          </div>
        </Col>
        <Col xs={10} style={{ width: '87.5%' }} className="main-content">
          {activeKey === 'profile' && <UserProfile />}
          {activeKey === 'activity' && <ActivityFeed />}
          {activeKey === 'projects' && <Projects />}
          {activeKey === 'exploit-centre' && <ExploitCentre />}
          {activeKey === 'training' && <Training />}
          {activeKey === 'writeups' && <Writeups />}
          {activeKey === 'roster' && <Roster />}
          {activeKey === 'resource-centre' && <ResourceCentre />}
          {activeKey === 'professional-development' && <ProDevelopment />}
          {activeKey === 'analytics' && <Analytics />}
          {activeKey === 'admin' && <AdminPanel />}
        </Col>
      </Row>
    </Container>
  );
}

export default Dashboard;
